import React, { memo } from 'react';
import { InvestorTopbar } from './InvestorTopbar';
import { StandardTopbar } from './StandardTopbar';
import { useSession } from '@hum/api/src/Session/useSession';

export type TopbarProps = {
  title?: string;
  fixedBar?: boolean;
  links?: any[];
  background?: string;
  flow?: boolean;
};

// TODO: Re-evalute architecture during tech debt sprint
export const Topbar = memo(
  ({
    title,
    fixedBar,
    links,
    background = 'bg-gray-900',
    flow,
  }: TopbarProps) => {
    const { user } = useSession();

    const isAdmin = user?.isAdmin;
    const isCompany = user?.isCompanyAdmin || user?.isCompany;
    const isInvestor = user?.isFund;

    if (isAdmin || isCompany)
      return (
        <StandardTopbar
          title={title}
          fixedBar={fixedBar}
          links={links}
          background={background}
          flow={flow}
        />
      );

    if (isInvestor)
      return (
        <InvestorTopbar
          title={title}
          fixedBar={fixedBar}
          links={links}
          background={background}
          flow={flow}
        />
      );

    return null;
  }
);
Topbar.displayName = 'Topbar';
